module.exports = __webpack_public_path__ + "img/mushroomsSmall.89f8b4b1.jpg";